import { HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoaderService } from '@modules/loaders/services/loader.service';
import { finalize, tap } from 'rxjs/operators';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(private loaderService: LoaderService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    let useInterceptor = false;
    if (req.headers.get('x-show-loader') === '1') {
      useInterceptor = true;
      this.loaderService.displayLoader();
    }
    // console.log({useInterceptor, s: req.url});

    return next.handle(req).pipe(
      finalize(() => {
        if (useInterceptor) {
          // this.loaderService.hideLoader();;
        }
      }),
      tap((event) => {
          if (useInterceptor) {
            if (event instanceof HttpResponse) {
              this.loaderService.hideLoader();
            }
          }
        }, () => {
          if (useInterceptor) {
            this.loaderService.hideLoader();
          }
        }
      )
    );
  }
}
